import GenericVModel from '@components/mixins/genericVModel'

export default {
  name: 'EditBlockColorPicker',
  mixins: [GenericVModel],
  props: {
    showOpacity: {
      required: false,
      default: true,
    },
  },
  methods: {
    colorChanged(val) {
      this.input = val
    },
  },
}
